export default __webpack_public_path__ + "static/media/144px_x_40px_white-09_1.b6434caa.svg";